import axiosInstance from '../axios-instance.ts';
import { ApiResponse, ApiParams } from '@models/api.model.ts';
import {
  UnitReqModel,
  UnitsModel
} from '@models/departments-and-units/units.model.ts';

export const getUnits = async (
  params?: ApiParams
): Promise<ApiResponse<UnitsModel>> => {
  const response = await axiosInstance.get('/pms/departmentUnits/getter', {
    params
  });
  return response.data;
};

export const getAllUnits = async (): Promise<UnitsModel[]> => {
  const response = await axiosInstance.get('/pms/departmentUnits/all');
  return response.data;
};

export const getAssignedAdmin = async (): Promise<any[]> => {
  const response = await axiosInstance.get('/pms/users/adminListByOrg');
  return response.data;
};

export const createUnit = async (body: UnitReqModel): Promise<UnitsModel> => {
  return await axiosInstance.post(`/pms/departmentUnits`, body);
};

export const editUnit = async (
  body: UnitReqModel,
  id: number
): Promise<UnitsModel> => {
  return await axiosInstance.put(`/pms/departmentUnits/${id}`, body);
};

export const changeStatus = async (
  id: number,
  isActive: boolean
): Promise<any> => {
  const response = await axiosInstance.put(
    `/pms/departmentUnits/changeStatus/${id}`,
    {
      status: isActive
    }
  );
  return response.data;
};
